// handleStream.js (Utility Function)
export const handleStream = async (reader, updateStreamingHistoryCallback) => {
    const decoder = new TextDecoder("utf-8");
  
    const handleStreamRecursively = async () => {
      const { done, value } = await reader.read();
  
      if (done) {
        return;
      }
  
      const dataStrings = decoder
        .decode(value)
        .trim()
        .split("data: ")
        .filter(Boolean);
  
      dataStrings.forEach((data) => {
        try {
          const rawData = JSON.parse(data);

          // Normalize new BE field names to the existing internal shape
          const parsedData = {
            ...rawData,
            message_id: rawData.message_id ?? rawData.msg_ref,
            assistant: rawData.assistant ?? rawData.bot,
            user_message: rawData.user_message ?? rawData.mem_msg,
          };

          updateStreamingHistoryCallback(parsedData);
        } catch (error) {
          console.error("Error parsing data", error);
        }
      });
  
      await handleStreamRecursively();
    };
  
    await handleStreamRecursively();
  };
  